/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:variable-name

import { EntityVersion, ID, WithVersion } from '@gh/common-shared-data';
import { createEnum, EnumSet, WithOptimisticLock } from '@gh/core-data';

export const ChecklistStatus = createEnum('MOBILE_CHECKLIST_STATUS', {
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
});

export type ChecklistStatus = EnumSet<typeof ChecklistStatus>;

export type ChecklistDto = WithOptimisticLock<{
  id: ID;
  name: string;
  status: ChecklistStatus;
  version: EntityVersion;
  etag?: string;
  sortOrder: number;
  notEditable: boolean;
  parentId?: number;
}>;

export const ChecklistElementType = createEnum('CHECKLIST_ELEMENT_TYPE', {
  Checklist: 1,
  Signature: 2,
  Text: 3,
  Date: 4,
  DateTime: 5,
});

export type ChecklistElementType = EnumSet<typeof ChecklistElementType>;

export type ChecklistDetailsDto = WithOptimisticLock<WithVersion<{
  id?: ID;
  name: string;
  notEditable: boolean;
  checklistElements: ChecklistSectionDto[];
  version: EntityVersion;
  checklistLevel: number;
  status: ChecklistStatus;
  parentId?: ID;
}>>;

export type ChecklistSectionBaseDto = {
  title: string;
  elementType: Maybe<ChecklistElementType>;
};
export type ChecklistSectionDto = ChecklistSectionBaseDto & {
  elementId: ID;
  checklistItems: ChecklistClauseDto[];
};

export type ChecklistClauseDto = {
  title: string;
};
